import { render, staticRenderFns } from "./OriginalMessage.vue?vue&type=template&id=2dfb3d7d&"
import script from "./OriginalMessage.vue?vue&type=script&lang=js&"
export * from "./OriginalMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports